/**
 * Aspect targets for AI Expand / outpaint prep.
 * width × height define the ratio only; expansion is in source-image pixels.
 *
 * shape: visual cue for the card icon (landscape | square | portrait | ultrawide | tall)
 */
export const OUTPAINT_ASPECT_PRESETS = [
  {
    id: "4-3",
    label: "Landscape",
    ratioLabel: "4:3",
    dimsLabel: "4 × 3",
    shape: "landscape",
    targetWidth: 4,
    targetHeight: 3,
  },
  {
    id: "16-9",
    label: "Widescreen",
    ratioLabel: "16:9",
    dimsLabel: "16 × 9",
    shape: "landscape",
    targetWidth: 16,
    targetHeight: 9,
  },
  {
    id: "3-4",
    label: "Portrait",
    ratioLabel: "3:4",
    dimsLabel: "3 × 4",
    shape: "portrait",
    targetWidth: 3,
    targetHeight: 4,
  },
  {
    id: "1-1",
    label: "Square",
    ratioLabel: "1:1",
    dimsLabel: "1 × 1",
    shape: "square",
    targetWidth: 1,
    targetHeight: 1,
  },
  {
    id: "9-16",
    label: "Story",
    ratioLabel: "9:16",
    dimsLabel: "9 × 16",
    shape: "tall",
    targetWidth: 9,
    targetHeight: 16,
  },
  {
    id: "21-9",
    label: "Cinematic",
    ratioLabel: "21:9",
    dimsLabel: "21 × 9",
    shape: "ultrawide",
    targetWidth: 21,
    targetHeight: 9,
  },
];

export const OUTPAINT_OUTPUT_FORMATS = [
  { id: "webp", name: "WebP", label: "Smallest file size" },
  { id: "png", name: "PNG", label: "Lossless with transparency" },
  { id: "jpg", name: "JPG", label: "Wide compatibility" },
];

export function getOutpaintAspectPreset(id) {
  return OUTPAINT_ASPECT_PRESETS.find((p) => p.id === id) || null;
}

export function getOutpaintOutputFormat(id) {
  return OUTPAINT_OUTPUT_FORMATS.find((f) => f.id === id) || OUTPAINT_OUTPUT_FORMATS[0];
}
